export default {
    unsubscribed_contacts_delete_title: "Delete Unsubscribed Contacts",
    unsubscribed_contacts_delete_do_you_want_to: "Do you want to delete unsubscribed contacts?",
    unsubscribed_contacts_delete_have_been_removed: "Unsubscribed contact have been deleted",
}